import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to toggle tasklist view between column-view and list-view
 */
export class TasklistToggleViewCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.TASKLIST_TOGGLE_VIEW;

    public tags = ['ui', 'tasklist', 'view'];

    /**
     * Creates a new command to toggle tasklist view
     */
    constructor() {
        super('tasklist', 'system', undefined);
    }
}